import sendRequest from "../fetch"
import api from '../url'
import Qs from 'qs'
import { cleanParams } from "@/utils";
import downloadFile from "../download";
import { localTime } from "@/utils/utils.js";


const _base = "courseResult/";

//  教学计划列表（含成绩）查询-分页
export const myPlanCoursePage = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "myPage", {
           data: _params,
           method: "GET",
         });
       };



// WEBPACK FOOTER //
// ./src/fetch/api/myPlanCourse.js